import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import PaymentProofTemplateForm from "../../components/call-center/PaymentProofTemplateForm";
import useCallCenterT from "../../hooks/useCallCenterT";
import {
  getOrganizationPaymentProofTemplate,
  updateOrganizationPaymentProofTemplate,
} from "../../service/CallCenterPaymentProofTemplate";

const CallCenterPaymentProofTemplatePage = () => {
  const t = useCallCenterT();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [template, setTemplate] = useState({});

  useEffect(() => {
    const loadTemplate = async () => {
      try {
        setLoading(true);
        const response = await getOrganizationPaymentProofTemplate();
        setTemplate(response?.template || {});
      } catch (error) {
        toast.error(error?.message || t("ccPaymentProofTemplateLoadFailed"));
      } finally {
        setLoading(false);
      }
    };
    loadTemplate();
  }, [t]);

  const handleSubmit = async (nextTemplate) => {
    setSaving(true);
    try {
      const response = await updateOrganizationPaymentProofTemplate(nextTemplate);
      setTemplate(response?.template || nextTemplate);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f9fafb] p-6">
      <div className="mx-auto max-w-5xl">
        <header className="mb-6">
          <Link
            to="/call-center/ticket-settings?tab=statuses"
            className="mb-4 inline-flex text-sm font-medium text-slate-500 transition hover:text-[#2B7FFF]"
          >
            {t("ccBack")}
          </Link>
          <h1 className="text-[28px] font-bold tracking-tight text-[#111827]">
            {t("ccPaymentProofTemplateTitle")}
          </h1>
          <p className="mt-1 text-sm text-[#6b7280]">{t("ccPaymentProofTemplatePageHint")}</p>
        </header>

        {loading ? (
          <div className="rounded-2xl border border-slate-200/80 bg-white p-8 text-center text-sm text-slate-500 shadow-sm">
            {t("ccLoading")}
          </div>
        ) : (
          <div className="rounded-2xl border border-slate-200/80 bg-white p-6 shadow-sm sm:p-8">
            <PaymentProofTemplateForm
              initialTemplate={template}
              onSubmit={handleSubmit}
              onTemplateUpdated={(nextTemplate) =>
                setTemplate((current) => ({
                  ...current,
                  ...nextTemplate,
                }))
              }
              saving={saving}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CallCenterPaymentProofTemplatePage;
